import { render, staticRenderFns } from "./TypeFamily.vue?vue&type=template&id=2251b3c4&"
import script from "./TypeFamily.vue?vue&type=script&lang=js&"
export * from "./TypeFamily.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports